// ATTRIB: DoOnceService is MWKrom Software.

class DoOnceService {

  doOnceActivity = {}
  
  doOnce (key, fcn) {
    if (this.doOnceActivity[key]) {
      console.log("doOnce returning since running - #{key}")
      return
    }
    this.doOnceActivity[key] = true;
    var me = this;
    var done = function() {
      me.doOnceActivity[key] = false;
    }
      
    fcn().then(done, done).catch(done);
  }
}

var doOnceService = new DoOnceService()
export { DoOnceService, doOnceService }

